export const CONFIRMATION_MESSAGE =
  "Are you sure you want to exit? changes will be lost.";

export enum EDIT_FORMDEFINITION_TABS {
  "Form",
  "Stages",
}
